import { motion } from 'framer-motion'
import { Shield } from 'lucide-react'
import featureConsultoria from '../../../../assets/images/doctor-legal/ilustracoes/feature_consultoria.png'

const benefits = [
  'Agendamento direto pela plataforma',
  'Consulta especializada e com sigilo garantido',
  'Orientações preventivas para casos sensíveis',
]

export default function Consultancy({ textVariants }) {
  return (
    <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-8">
      <motion.div
        className="w-full lg:w-[45%] flex flex-col items-start text-left order-1"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={textVariants}
      >
        <span className="badge-info mb-6 !bg-text-primary !text-white">
          Consultoria
        </span>
        <h3 className="text-[24px] md:text-[30px] font-bold text-text-primary tracking-tight mb-4">
          Um especialista humano a um clique.
        </h3>
        <p className="text-base md:text-[18px] text-text-secondary leading-relaxed mb-0 md:mb-6">
          <span className="hidden md:inline">
            Videochamada com advogados especializados em direito médico. Sigiloso, direto e agendado pelo app — para quando você precisa de uma resposta de verdade.
          </span>
          <span className="md:hidden">
            Consultorias via videochamada com advogados especialistas em direito médico.
          </span>
        </p>
        <ul className="space-y-3 mb-10">
          {benefits.map((item, idx) => (
            <li
              key={idx}
              className="flex items-center gap-3 text-text-secondary text-[16px]"
            >
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-tint flex items-center justify-center">
                <Shield className="w-3 h-3 text-accent-primary" />
              </div>
              {item}
            </li>
          ))}
        </ul>
        <a href="#planos" className="btn-primary hidden lg:inline-flex">
          Fazer pré-cadastro
        </a>
      </motion.div>

      <div className="w-full lg:w-[55%] flex items-center justify-center order-2">
        <img
          src={featureConsultoria}
          alt="Ilustração de consultoria jurídica"
          className="w-full max-w-[400px] sm:max-w-[500px] lg:max-w-none h-auto object-contain"
        />
      </div>

      <div className="w-full lg:hidden order-3">
        <a href="#planos" className="btn-primary w-full justify-center">
          Fazer pré-cadastro
        </a>
      </div>
    </div>
  )
}
